/** Minimal shape of the Auth0 user fields we derive a name from. */
export interface Auth0NameSource {
  given_name?: string;
  family_name?: string;
  name?: string;
  email?: string;
}

/**
 * Resolve the name shown for the user (feature F). A non-empty stored display
 * name always wins; otherwise fall back to the Auth0-derived name, then email.
 */
export function resolveDisplayName(
  stored: string | null | undefined,
  user?: Auth0NameSource,
): string {
  const s = (stored || '').trim();
  if (s) return s;
  if (user?.given_name && user?.family_name) {
    return `${user.given_name} ${user.family_name}`;
  }
  return user?.name ?? user?.email ?? '';
}
